import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { CasosService } from './casos.service';
import { ActivatedRoute } from '@angular/router';
import { Caso } from './casos.model';
import { NotificationsService } from '../core/service/notifications.service';
import { Select2Data } from 'ng-select2-component';
import { getCurrentLanguage } from '../core/helpers/utils';

@Component({
  selector: 'app-comentarios-internos',
  templateUrl: './comentarios-internos.component.html',
  styleUrls: ['./comentarios-internos.component.scss']
})
export class ComentariosInternosComponent implements OnInit {

  @Output() refreshCase = new EventEmitter<void>();

  caso!: Caso;
  loaded: boolean = false;
  error: string = '';

  incidenciasList: Select2Data = [];
  incidenciasArray: string[] = [];

  currentLanguage: string = getCurrentLanguage();

  constructor(
    private casosService: CasosService,
    private route: ActivatedRoute,
    private notificationsService: NotificationsService
  ) { }

/*
// Procesamiento datos para profesiones
const dataProfesionesFromDB = resProfesiones;
const convertedProfesionesData = dataProfesionesFromDB.map(item => ({
  value: item.nombre,
  label: item[this.currentLanguage] // Asumiendo que el campo se llama 'nombre'
}));
this.profesiones = convertedProfesionesData;
*/

  ngOnInit(): void {
    const id_caso = this.route.snapshot.paramMap.get('id');
    if (id_caso) {
      this.casosService.getCaso(id_caso).subscribe({
        next: (caso) => {
          this.caso = caso || {};
          //this.caso.incidencias = this.caso.incidencias || []; // Inicializar si es undefined

          // Llama al servicio para obtener las incidencias
          this.casosService.getIncidencias().subscribe({
            next: (incidencias) => {
              // Procesar las incidencias para el select2
              this.incidenciasList = incidencias.map(incidencia => ({
                value: incidencia.nombre,
                label: incidencia[this.currentLanguage] // Ajusta según el idioma actual (es/en)
              }));
              this.incidenciasArray = this.caso.incidencias ?? [];              
              this.loaded = true; // Marca el componente como cargado después de asignar incidenciasList              
            },
            error: (error) => {
              this.notificationsService.showErrorNotification(error);
              this.loaded = true; // Permitir cargar el formulario incluso si hay un error
            }
          });
        },
        error: (error) => {
          console.error('Error al cargar el caso:', error);
          this.error = error;
          this.loaded = false;
        }
      });
    }
  }


  onSubmit(f: any): void {
    if (f.valid && this.caso.id) {
      const updatedData: any = {
        comentarios: this.caso.comentarios,
        incidencias_otras: this.caso.incidencias_otras,
        rebeldia: this.caso.rebeldia,
        escrutinios_revision_comision: this.caso.escrutinios_revision_comision,
        incidencias: this.caso.incidencias
      };

      this.casosService.updateCaso(this.caso.id, updatedData).subscribe({
        next: () => {
          const updateCasoSuccessMessage: string = $localize `:@@updateCasoSuccessMessage:Datos guardados correctamente`;
          this.notificationsService.showSuccessNotification(updateCasoSuccessMessage);
          this.refreshCase.emit();
        },
        error: (error) => {
          this.notificationsService.showErrorNotification(error)
          //console.error('Error al guardar los cambios:', error);
        }
      });
    }
  }

  isCaseClosed(): boolean {
    const estadosCerrados = ['CERRADO_LAUDO', 'CERRADO_ACUERDO', 'CERRADO_OTROS', 'CERRADO_REENVIO'];
    return estadosCerrados.includes(this.caso.estado ?? '');
  }
  
}
